// DomainsPage.jsx — CONTAINER da tela "Domínio próprio".
//
// A lógica toda mora em `useDomains` (o contrato @v3 tem três blocos, três diálogos e uma linha
// do tempo — misturar isso com JSX deixaria os dois ilegíveis). Aqui só fica a ligação com a View.
//
// ⚠️ Esta tela NÃO é embutível, e isso é regra, não limitação (André, 08/09/2026):
//
//   "cards e afins na home JAMAIS são partes/partials de página de menu. São construções feitas
//    especificamente pra home. Nada se compartilha de front entre, por exemplo, card de domínio
//    da home e página de domínio."
//
// Existiu aqui um modo embutido (uma prop booleana, em inglês) que a Home usava. Ele
// transformou a Home num painel de domínios — lista de endereços, linha do tempo e renovação,
// que são gestão e pertencem a esta tela. Hoje a Home tem os cards `domainOffer` e
// `domainPayment` PRÓPRIOS, desenhados dentro da DashboardView e vindos de `GET /v1/home`.
//
// O nome da prop não é citado de propósito: o teste de smoke procura por ele no texto deste
// arquivo para garantir que o mecanismo não volte.
//
// Se amanhã a tela de Páginas precisar oferecer domínio, o caminho é o mesmo: massa do servidor
// + desenho próprio daquela tela. Não importar esta.
import { useNavigate } from 'react-router-dom';
import useDomains from './domains/useDomains';
import DomainsView from './domains/DomainsView';

export default function DomainsPage() {
  const navigate = useNavigate();
  const { vm, actions } = useDomains();

  // Navegação é do container, não do hook: o hook não conhece rotas.
  return <DomainsView vm={vm} actions={{ ...actions, onCreatePage: () => navigate('/pages') }} />;
}
